import React, { FC } from 'react';
import MeasurementGroup from '@components/EntityDrawers/drawers/Conceptual/inputs/MeasurementGroup';

const Advanced: FC = () => {
  return <MeasurementGroup />;
};

export default Advanced;
